import request from '@/utils/request'; // 获取列表

export function fetchList(data) {
  return request({
    url: '/whg-park/api/noticeType/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/noticeType/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/noticeType/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/whg-park/api/noticeType/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/noticeType/update',
    method: 'post',
    data: data
  });
}
export function fetchClassList(data) {
  return request({
    url: '/whg-park/api/noticeType/update',
    method: 'post',
    data: data
  });
}
export function fetchDetailForManage(data) {
  return request({
    url: '/whg-park/api/noticeType/update',
    method: 'post',
    data: data
  });
}